import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createProductItem,
  getAllProductItems,
  getDataForEdit,
  updateProductItem,
  deleteProductItem,
} from "../../store/Products/ProductSliceApi";

import {
  getAllQualityItems,
  getProductItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { productSliceAction } from "../../store/Products/ProductSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsProducts } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsProducts } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialProductFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorProductFormData } from "../../ConstantData/ErrorOption";

function Product() {
  const [makeProductSelect, setMakeProductSelect] = useState("text");
  let newFormOptionsProducts = JSON.parse(
    JSON.stringify(AddMoreFormOptionsProducts)
  );
  const [createOrAddMore, setCreateOrAddMore] = useState("normalcreate");
  let newFormOptionsProductsText = JSON.parse(
    JSON.stringify(FormOptionsProducts)
  );

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllProductItems());
    // dispatch(getAllQualityItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const productList = useSelector((state) => state.product.productList);

  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.product.initialData
  );
  //for normal duplicate form input data initilization
  const InitialFormDuplicateDataStore = useSelector(
    (state) => state.product.initialDuplicateData
  );
  const productEditData = useSelector((state) => state.product.dataEdit);
  let productFormError = useSelector((state) => state.product.errorData);
  let isError = useSelector((state) => state.product.isError);
  productFormError = { ...ErrorProductFormData, ...productFormError };
  const qualityList = useSelector((state) => state.applevel.qualityList);
  const productListAll = useSelector((state) => state.applevel.productList);

  function addOptionForSelectFieldDuplicate(FormOption, list, optionName) {
    newFormOptionsProducts = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsProductsText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (qualityList.length > 0) {
    //to chage subquality option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsProducts,
      qualityList,
      "Quality"
    );
  }

  if (productListAll.length > 0) {
    //to chage product option coming from server
    addOptionForSelectField(FormOptionsProducts, productListAll, "Name");
  }

  if (makeProductSelect === "text") {
    newFormOptionsProductsText = newFormOptionsProductsText.map((item) => {
      if (item?.labelName === "Name") {
        item.type = makeProductSelect;
      }
      return item;
    });
  }
  if (makeProductSelect === "select") {
    newFormOptionsProductsText = newFormOptionsProductsText.map((item) => {
      if (item?.labelName === "Name") {
        item.type = makeProductSelect;
      }
      return item;
    });
  }

  const setProducType = (type, AddMore) => {
    setMakeProductSelect(type);
    setCreateOrAddMore(AddMore);
  };

  const headTitleLabel = headTitle(FormOptionsProducts, [
    "Name",
    "Quality",
    "Price(Rs)",
    "Discount amount",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialProductFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deleteProductItem}
      createFun={createProductItem} //create function coming from store
      updateFun={updateProductItem} //update function coming from store
      FormOptions={newFormOptionsProductsText}
      NewFormOptions={newFormOptionsProducts}
      OptionName="Create Product"
      OptionNameList="Product"
      generalList={productList}
      headTitle={headTitleLabel}
      EditData={productEditData}
      isError={isError}
      ErrorData={productFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={productSliceAction.setErrorData}
      generalModuleList={qualityList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={true}
      extraButtonText={"Add Quality"}
      FormStyle={"!w-[90%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={true} // to create second button to add extra form
      setProducType={setProducType}
      createOrAddMore={createOrAddMore}
      isSuccess={isSuccess}
    />
  );
}

export default Product;
